



































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';

export class User {
  id: number
  login_id: string
  name: string
  curriculum_id: number[]
  subject_codes: string[]
  role: string
  is_selected: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.login_id = x.login_id;
    this.name = x.name;
    this.curriculum_id = !x.curriculum_id ? [] : x.curriculum_id.split(",").map((y: string) => Number(y));
    this.subject_codes = x.subject_codes;
    this.role = x.role;
  }
}

export class Student {
  id: number
  student_no_character: string
  grade: number
  room_name: string
  student_no: number
  student_name: string
  email: string
  is_selected: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.student_no_character = x.student_no_character;
    this.grade = x.grade;
    this.room_name = x.room_name;
    this.student_no = x.student_no;
    this.student_name = x.student_name;
    this.email = x.email;
    
    this.is_selected = x.is_selected;
  }
}

export interface SheetGroup {
  sheet_id: string
  room_name: string
  student_count: string
  is_uploaded: boolean
  student_no_characters: string[]
  students: Student[]
}

export interface Data {
  sheet_group_key: string
  isNew: boolean
  sheetBase: any
  sheetGroups: SheetGroup[]
  curriculums: any[]
  users: User[]
  modalUsers: User[]
  errors: any[]
  copySheets: any[]
  copyTargetSheet: any
  condition: any
  totalCount: number
  user_condition: any
  isAllCheckedUser: boolean
  students: Student[]
  grade_students: any[]
  selectedSheetGroup: SheetGroup
  isAllCheckedStudent: boolean
  isInitiarized: boolean
  isDispSortAnswerImageCheckbox: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalCopySheetRef = ref<InstanceType<typeof BModal>>();
    const modalStudentRef = ref<InstanceType<typeof BModal>>();
    const cancelButtonRef = ref<HTMLElement | null>(null);

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: null,
      isNew: context.root.$route.path.indexOf("new") != -1,
      sheetBase: {
        exec_date: "",
        name: "",
        curriculum_id: "",
        subject_name: "",
        subject_code: "",
        grade: "",
        created_by: null,
        browse_lock: false,
        edit_lock: false,
        is_sort_answer_image_enable: false,
        is_print_view_point: false,
        is_print_part1: false,
        is_linked_students: false,
        is_disp_correct_question_image: false,
        is_use_hosei: false,
        is_use_mark_recog_field: false,
        is_studnet_key_recog_enable: false,
      },
      sheetGroups: [],
      curriculums: [],
      users: [],
      modalUsers: [],
      errors: [],
      copySheets: [],
      copyTargetSheet: null,
      condition: {
        grade: "",
        month: "",
        sheet_group_key: "",
        curriculum_id: "",
        page: 1,
        row_count: Common.SheetListRowCount,
        is_digital_paper: false,
      },
      totalCount: 0,
      user_condition: {
        name: "",
        role: "",
      },
      isAllCheckedUser: false,
      students: [],
      grade_students: [],
      selectedSheetGroup: null,
      isAllCheckedStudent: false,
      isInitiarized: false,
      isDispSortAnswerImageCheckbox: false,
    });

    /******************************
     * 試験検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験検索
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_edit/search_sheet?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.copySheets = response.data.sheets;
        state.copyTargetSheet = null;
        state.totalCount = state.copySheets.length > 0 ? state.copySheets[0].at_full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * コピー対象試験選択
     ******************************/

    const setCopyTargetSheet = (sheet: any) => {
      state.copyTargetSheet = sheet;
      state.sheetBase.name = sheet.name;
      state.sheetBase.curriculum_id = sheet.curriculum_id;
      state.sheetBase.subject_name = sheet.subject_name;
      state.sheetBase.grade = sheet.grade;
      state.sheetBase.browse_lock = sheet.browse_lock;
      state.sheetBase.edit_lock = sheet.edit_lock;
      // 並び替え強制OPがONの場合はコピー元のフラグ問わずONでコピー
      state.sheetBase.is_sort_answer_image_enable = context.root.$store.getters.isOptionSortAnswerImageRequiredActive ? true : sheet.is_sort_answer_image_enable;
      state.sheetBase.is_print_view_point = sheet.is_print_view_point;
      state.sheetBase.is_print_part1 = sheet.is_print_part1;
      state.sheetBase.is_linked_students = sheet.is_linked_students;
      state.sheetBase.is_disp_correct_question_image = sheet.is_disp_correct_question_image;
      state.sheetBase.is_use_hosei = sheet.is_use_hosei;
      state.sheetBase.is_use_mark_recog_field = sheet.is_use_mark_recog_field;
      state.sheetBase.subject_code = sheet.subject_code;
      state.sheetBase.is_studnet_key_recog_enable = sheet.is_studnet_key_recog_enable;

      modalCopySheetRef.value.hide();
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      const pageCache = state.condition.page;
      state.condition = {
        grade: "",
        month: "",
        sheet_group_key: "",
        curriculum_id: "",
        page: pageCache,
        row_count: Common.SheetListRowCount,
        is_digital_paper: false,
        subject_code: "",
      };
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 編集可否
     ******************************/

    const isEditable = computed(() => {
      return state.sheetBase.created_by == null || state.sheetBase.created_by == context.root.$store.state.currentUser.login_id || context.root.$store.state.currentUser.role != Common.RoleEnum.Teacher2;
    });

    // 空のクラス情報作成
    const createEmptySheetGroup = () => {
      const info: SheetGroup = {
        sheet_id: "",
        room_name: "",
        student_count: "",
        is_uploaded: false,
        student_no_characters: [],
        students: [],
      };
      return info;
    }
    
    // クラス情報マイナスアイコン押下
    const deleteSheetGroup = (idx: number) => {
      state.sheetGroups.splice(idx, 1);
    }
    
    // クラス情報プラスアイコン押下
    const addSheetGroup = () => {
      state.sheetGroups.push(createEmptySheetGroup());
    }

    // 登録ボタン押下
    const entryClick = async () => {

      if(!validate()){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(!window.confirm("試験更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param = {
        sheet_base: state.sheetBase,
        sheet_groups: state.sheetGroups.filter(x => Number(x.student_count) > 0),
        copy_target_sheet_group_key: state.copyTargetSheet ? state.copyTargetSheet.sheet_group_key : null,
        scorable_login_ids: scorable_login_ids.value,
      }

      await http.post(`/api/teacher/sheet_edit`, param).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    // 更新ボタン押下
    const updateClick = async () => {

      if(!validate()){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(!window.confirm("試験更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param = {
        sheet_base: state.sheetBase,
        sheet_groups: state.sheetGroups.filter(x => Number(x.student_count) > 0),
        scorable_login_ids: scorable_login_ids.value
      }

      await http.post(`/api/teacher/sheet_edit/update/${state.sheet_group_key}`, param).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    // 削除ボタン押下
    const deleteClick = async () => {

      context.root.$bvModal.hide('modal-confirm')

      context.root.$store.dispatch("showOverlay");

      await http.delete(`/api/teacher/sheet_edit/${state.sheet_group_key}`).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    // バリデーション
    const validate = () => {
      state.errors = [];

      if(state.sheetBase.exec_date.length == 0){
        state.errors.push("実施日が入力されていません。");
      }

      if(state.sheetBase.name.length == 0){
        state.errors.push("試験名が入力されていません。");
      }

      if(!context.root.$store.getters.isOptionSchoolSubjectActive && !state.sheetBase.curriculum_id){
        state.errors.push("教科が選択されていません。");
      }

      if(state.sheetBase.grade.length == 0){
        state.errors.push("学年が選択されていません。");
      }

      if(state.sheetBase.is_linked_students){
        // 生徒管理で名簿同期する場合
        if(state.sheetGroups.filter(x => x.student_no_characters.length > 0).length == 0){
          state.errors.push(`受験者が0名です。`);
        }
      }else{
        // 生徒管理の名簿同期がない場合
        for(var i = 0; i < state.sheetGroups.length; i++){
          var sheetGroup = state.sheetGroups[i];

          if(sheetGroup.room_name.length == 0){
            state.errors.push(`クラス情報 ${i + 1}行目のクラス名が入力されていません。`);
          }

          if(sheetGroup.student_count.length == 0){
            state.errors.push(`クラス情報 ${i + 1}行目の人数が入力されていません。`);
          }else if(!/^\d+$/.test(sheetGroup.student_count)){
            state.errors.push(`クラス情報 ${i + 1}行目の人数に数字以外が入力されています。`);
          }else if(Number(sheetGroup.student_count) <= 0){
            state.errors.push(`クラス情報 ${i + 1}行目の人数が不正です。1以上の数字を入力してください。`);
          }
        }
      }

      return state.errors.length == 0;
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      // 編集の場合、DBからクラス・人数情報取得
      if(state.isNew){
        // 新規登録の場合、空のクラス情報を1行作成
        state.sheetGroups.push(createEmptySheetGroup());

        await http.get(`/api/teacher/sheet_edit/new`).then(response => {
          state.curriculums = response.data.curriculums;
          state.users = response.data.users.map((x: any) => new User(x));
          state.students = response.data.students.map((x: any) => new Student(x));
          state.sheetBase.is_linked_students = false; //context.root.$store.getters.isOptionStudentManageActive;
          state.sheetBase.browse_lock = !context.root.$store.getters.isAdminOrTeacher1 && context.root.$store.getters.isOptionSheetViewCreateUserOnlyActive;
          state.sheetBase.is_sort_answer_image_enable = context.root.$store.getters.isOptionSortAnswerImageRequiredActive;
          state.isDispSortAnswerImageCheckbox = !context.root.$store.getters.isOptionSortAnswerImageRequiredActive;
          state.isInitiarized = true;
          searchUser();
        });
      }else{
        state.sheet_group_key = context.root.$route.params.sheet_group_key;

        // APIで登録済み試験情報取得
        await http.get(`/api/teacher/sheet_edit?sheet_group_key=${state.sheet_group_key}`).then(response => {
          // 試験情報の１件目から表題情報取得
          state.sheetBase = {
            exec_date: response.data.sheets[0].exec_date,
            name: response.data.sheets[0].name,
            curriculum_id: response.data.sheets[0].curriculum_id ? response.data.sheets[0].curriculum_id : "",
            subject_name: response.data.sheets[0].subject_name,
            grade: response.data.sheets[0].grade,
            created_by: response.data.sheets[0].created_by,
            browse_lock: response.data.sheets[0].browse_lock,
            edit_lock: response.data.sheets[0].edit_lock,
            is_sort_answer_image_enable: response.data.sheets[0].is_sort_answer_image_enable,
            is_print_view_point: response.data.sheets[0].is_print_view_point,
            is_print_part1: response.data.sheets[0].is_print_part1,
            is_linked_students: response.data.sheets[0].is_linked_students,
            is_disp_correct_question_image: response.data.sheets[0].is_disp_correct_question_image,
            is_use_hosei: response.data.sheets[0].is_use_hosei,
            is_use_mark_recog_field: response.data.sheets[0].is_use_mark_recog_field,
            subject_code: response.data.sheets[0].subject_code,
            is_studnet_key_recog_enable: response.data.sheets[0].is_studnet_key_recog_enable,
          };

          state.students = response.data.students.map((x: any) => new Student(x));

          state.curriculums = response.data.curriculums;
          state.users = response.data.users.map((x: any) => new User(x));
          const scorable_login_ids = response.data.scorable_login_ids;

          context.root.$nextTick(() => {
            state.modalUsers.filter(x => scorable_login_ids.includes(x.login_id)).forEach(x => x.is_selected = true);

            const sheets = response.data.sheets.sort((a: any, b: any) => Common.strCmpLogicalW(a.room_name, b.room_name));

            // クラス情報取得
            const sheetGroups: SheetGroup[] = [];
            if(state.sheetBase.is_linked_students){
              grade_room_names.value.forEach(room_name => {
                const sheet = response.data.sheets.find((x: any) => x.room_name === room_name) || null;
                if(sheet){
                  const students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == sheet.room_name).sort((a, b) => a.student_no - b.student_no);
                  const student_no_characters = students.filter(x => x.is_selected).map(x => x.student_no_character);
                  
                  const sheetGroup = {
                    sheet_id: sheet.id,
                    room_name: room_name,
                    student_count: sheet.student_count,
                    is_uploaded: sheet.sheet_activities_count > 0,
                    students: students,
                    student_no_characters: student_no_characters,
                  };
                  sheetGroups.push(sheetGroup);
                }else{
                  // 受験者0名のクラスの場合
                  const sheetGroup = createEmptySheetGroup();
                  sheetGroup.room_name = room_name;
                  sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
                  sheetGroup.student_no_characters = [];
                  sheetGroup.student_count = sheetGroup.student_no_characters.length.toString();
                  sheetGroups.push(sheetGroup);
                }
              });
            }else{
              sheets.forEach((sheet: any) => {
                const sheetGroup: SheetGroup = {
                  sheet_id: sheet.id,
                  room_name: sheet.room_name,
                  student_count: sheet.student_count,
                  is_uploaded: sheet.sheet_activities_count > 0,
                  students: [],
                  student_no_characters: [],
                };
                sheetGroups.push(sheetGroup);
              });
            }
              
            state.sheetGroups = sheetGroups;
            state.isDispSortAnswerImageCheckbox = !context.root.$store.getters.isOptionSortAnswerImageRequiredActive || !state.sheetBase.is_sort_answer_image_enable;
            state.isInitiarized = true;
          });
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
          }
          window.history.back();
        });
      }

      context.root.$store.dispatch("hideOverlay");
    })

    /************************************************************
     * 教科・科目の変更監視
     ************************************************************/

    watch(() => [state.sheetBase.curriculum_id, state.sheetBase.subject_code], async (newVal: any, oldVal) => {

      state.users.forEach(x => x.is_selected = false);

      let modalUsers = state.users.map(x => x);

      if(state.sheetBase.curriculum_id){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.curriculum_id.includes(state.sheetBase.curriculum_id));
      }

      if(context.root.$store.getters.isOptionSchoolSubjectActive && state.sheetBase.subject_code){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.subject_codes.includes(state.sheetBase.subject_code));
      }

      state.modalUsers = modalUsers.sort((a, b) => {
        if (a.role === b.role) {
          return a.name.localeCompare(b.name);
        }
        return a.role.localeCompare(b.role);
      });
    });

    /************************************************************
     * ユーザモーダルの全件選択チェックボックず変更監視
     ************************************************************/
    
    watch(() => state.isAllCheckedUser, async (newVal, oldVal) => {
      state.modalUsers.forEach(x => x.is_selected = newVal);
    });

    /************************************************************
     * ユーザモーダルのユーザ検索
     ************************************************************/

    const searchUser = () => {
      let modalUsers = state.users.map(x => x);

      if(state.sheetBase.curriculum_id){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.curriculum_id.includes(state.sheetBase.curriculum_id));
      }

      if(context.root.$store.getters.isOptionSchoolSubjectActive && state.sheetBase.subject_code){
        modalUsers = modalUsers.filter(x => x.role == "teacher1" || x.subject_codes.includes(state.sheetBase.subject_code));
      }

      if(state.user_condition.name){
        modalUsers = modalUsers.filter(x => x.name.includes(state.user_condition.name));
      }

      if(state.user_condition.role){
        modalUsers = modalUsers.filter(x => x.role == state.user_condition.role);
      }

      state.modalUsers = modalUsers.sort((a, b) => {
        if (a.role === b.role) {
          return a.name.localeCompare(b.name);
        }
        return a.role.localeCompare(b.role);
      });
    }

    const clearUserCondition = () => {
      state.user_condition = {name: "", role: ""};
    }

    /************************************************************
     * 選択ユーザのログインID
     ************************************************************/

    const scorable_login_ids = computed((): string[] => {
      return state.modalUsers.filter(x => x.is_selected).map(x => x.login_id);
    });


    /************************************************************
     * 学年プルダウン変更監視
     ************************************************************/

    watch(() => state.sheetBase.grade, async () => {
      if(!state.isInitiarized || !state.sheetBase.is_linked_students){
        return;
      }

      state.sheetGroups = [];
      grade_room_names.value.forEach(room_name => {
        const sheetGroup = createEmptySheetGroup();
        sheetGroup.room_name = room_name;
        sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
        sheetGroup.student_no_characters = [];
        sheetGroup.student_count = "0";
        state.sheetGroups.push(sheetGroup);
      })
    });

    /************************************************************
     * 生徒名簿連携チェックボック変更監視
     ************************************************************/

    watch(() => state.sheetBase.is_linked_students, async (newVal) => {
      if(!state.isInitiarized){
        return;
      }

      if(newVal){
        state.sheetGroups = [];
        grade_room_names.value.forEach(room_name => {
          const sheetGroup = createEmptySheetGroup();
          sheetGroup.room_name = room_name;
          sheetGroup.students = state.students.filter(x => x.grade == state.sheetBase.grade && x.room_name == room_name).sort((a, b) => a.student_no - b.student_no);
          sheetGroup.student_count = "0";
          sheetGroup.student_no_characters = [];
          state.sheetGroups.push(sheetGroup);
        })
      }else{
        state.sheetGroups = [createEmptySheetGroup()];
      }
    });

    /************************************************************
     * 選択中の学年に設定されているクラス一覧
     * 生徒マスタリストから取得
     ************************************************************/

    const grade_room_names = computed(() => {
      return Array.from(
        new Set(state.students.filter(student => student.grade === state.sheetBase.grade).map(student => student.room_name))
      ).sort((a: string, b: string) => Common.strCmpLogicalW(a, b));
    });

    const showStudentModal = (sheetGroup: SheetGroup) => {
      state.selectedSheetGroup = sheetGroup;
      modalStudentRef.value.show();
    }

    const onStudentModalClose = () => {
      state.selectedSheetGroup.student_count = state.selectedSheetGroup.student_no_characters.length.toString();
    }

    /************************************************************
     * 生徒モーダルの全件選択チェックボックス変更監視
     ************************************************************/
    
    watch(() => state.isAllCheckedStudent, async (newVal) => {
      if(newVal){
        state.selectedSheetGroup.student_no_characters = state.selectedSheetGroup.students.map(x => x.student_no_character);
      }else{
        state.selectedSheetGroup.student_no_characters = [];
      }
    });

    const isUploaded = computed(() => {
      return state.sheetGroups.filter(x => x.is_uploaded).length > 0;
    });

    return {
      ...toRefs(state),
      cancelButtonRef,
      isEditable,
      deleteSheetGroup,
      addSheetGroup,
      entryClick,
      updateClick,
      deleteClick,
      modalCopySheetRef,
      searchClick,
      clearCondition,
      convertExecDate,
      changePage,
      setCopyTargetSheet,
      searchUser,
      clearUserCondition,
      grade_room_names,
      modalStudentRef,
      showStudentModal,
      onStudentModalClose,
      isUploaded,
    }
  }
})
